export const AI_UUID_COOKIE = `ai_chat_uuid`
export const AI_UUID_TTL_DAYS = 7
export const AI_SHOW_OPERATOR_KEY = `ai_chat_show_operator`
export const AI_SHOW_PERSONAL_ACCOUNT_KEY = `ai_chat_show_personal_account`
